import { usePrenotaStore } from "@/_modulos/prenota/inclusao"
import { z } from "zod"

export const vencimentoSchema = z.object({
  Parcela: z.string().min(1),
  Vencimento: z.string().regex(/^\d{8}$/, "Data deve estar em formato DDMMYYYY"),
  Valor: z.number().positive(),
})

export const filtroFaturasSchema = z.object({
  fornecedores: z.array(z.object({
    A2_COD: z.string().min(1),
    A2_LOJA: z.string().min(1),
    A2_NOME: z.string().min(1),
    A2_CGC: z.string().optional(),
  })).min(1, "Selecione ao menos um fornecedor"),

  filial: z.string().min(1, "Filial obrigatória"),

  date: z.object({
    from: z.date(),
    to: z.date().optional(),
  }).nullable().optional(),

  dataInicial: z.string().length(8).or(z.literal("")).optional(), // yyyyMMdd ou vazio
  dataFinal: z.string().length(8).or(z.literal("")).optional(),

  fornecedorFatura: z.object({
    A2_COD: z.string().min(1),
    A2_LOJA: z.string().min(1),
    A2_NOME: z.string().optional(),
  }).nullable(),

  faturas: z.array(z.object({
    Z10_CHAVE: z.string(),
    F1_DOC: z.string(),
    F1_SERIE: z.string(),
    F1_FORNECE: z.string(),
    F1_LOJA: z.string(),
    F1_EMISSAO: z.string(),
    F1_CHVNFE: z.string(),
    VALOR: z.number(),
    checked: z.boolean().optional(),
  })),

  observacao: z.string().optional(),
  anexos: z.any(), // placeholder só pro form mostrar erro
  rec: z.number().optional(),
}).superRefine((values, ctx) => {
  const anexos = usePrenotaStore.getState().draft.anexos
  if (!anexos || anexos.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Selecione pelo menos um anexo",
      path: ["anexos"], // <- bate com o FormField name="anexos"
    })
  }
})

export type FiltroFaturasFormValues = z.infer<typeof filtroFaturasSchema>
